(() => {
  if (window.CTEDestinationNavigation) return;
  const instances = new Map();

  function mount(root) {
    if (instances.has(root)) return;
    const nav = root.querySelector('.ct-guide-jumps');
    if (!nav) return;
    const header = document.querySelector('.cte-header') || document.querySelector('.section-header');
    const headerTarget = header && (header.closest('.ct-smart-header-target') || header.closest('.section-header') || header);
    const headerNodes = [...new Set([header, headerTarget].filter(Boolean))];
    const anchor = document.createElement('div');
    anchor.setAttribute('aria-hidden', 'true');
    anchor.className = 'ct-guide-nav-anchor';
    // Sense hides empty divs. This spacer must keep a layout box for measurement.
    anchor.style.display = 'block';
    nav.parentNode.insertBefore(anchor, nav);
    let frame = 0;
    const headerTransitions = new Set();

    const update = () => {
      frame = 0;
      const headerBounds = header ? header.getBoundingClientRect() : null;
      const headerHeight = headerBounds ? Math.ceil(headerBounds.height) : 0;
      const sticky = headerNodes.some(node => ['sticky', 'fixed'].includes(getComputedStyle(node).position));
      // The custom CTE header hides by transforming its section wrapper.
      // Its visible bottom, including the transition, is the usable nav offset.
      const top = sticky && headerBounds ? Math.max(0, Math.ceil(Math.min(headerBounds.bottom, headerBounds.height))) : 0;
      const canReveal = header && (sticky || header.querySelector('sticky-header'));
      const navHeight = Math.ceil(nav.getBoundingClientRect().height);
      const anchorBounds = anchor.getBoundingClientRect();
      const measurable = anchorBounds.width > 0;
      const fixed = measurable && anchorBounds.top <= top;
      root.style.setProperty('--ct-guide-header-offset', `${top}px`);
      root.style.setProperty('--ct-guide-anchor-offset', `${(canReveal ? headerHeight : 0) + navHeight + 20}px`);
      if (measurable) {
        root.style.setProperty('--ct-guide-nav-left', `${anchorBounds.left}px`);
        root.style.setProperty('--ct-guide-nav-width', `${anchorBounds.width}px`);
      }
      nav.classList.toggle('is-fixed', fixed);
      anchor.style.height = fixed ? `${navHeight}px` : '0px';
      if (headerTransitions.size) schedule();
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const trackTransition = event => {
      if (event.target !== headerTarget || !['transform', 'top'].includes(event.propertyName)) return;
      if (event.type === 'transitionrun') headerTransitions.add(event.propertyName);
      else headerTransitions.delete(event.propertyName);
      schedule();
    };
    const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    if (resize) {
      resize.observe(nav);
      resize.observe(anchor);
      headerNodes.forEach(node => resize.observe(node));
    }
    const mutations = header && typeof MutationObserver === 'function' ? new MutationObserver(schedule) : null;
    if (mutations) headerNodes.forEach(node => mutations.observe(node, { attributes: true, attributeFilter: ['class', 'style'] }));
    const transitionEvents = ['transitionrun', 'transitionend', 'transitioncancel'];
    if (headerTarget) transitionEvents.forEach(name => headerTarget.addEventListener(name, trackTransition));
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    update();
    instances.set(root, () => {
      if (frame) cancelAnimationFrame(frame);
      if (resize) resize.disconnect();
      if (mutations) mutations.disconnect();
      if (headerTarget) transitionEvents.forEach(name => headerTarget.removeEventListener(name, trackTransition));
      window.removeEventListener('resize', schedule);
      window.removeEventListener('scroll', schedule);
      nav.classList.remove('is-fixed');
      anchor.remove();
      instances.delete(root);
    });
  }

  function init(scope = document) {
    if (scope.matches && scope.matches('.ct-guide-page')) mount(scope);
    scope.querySelectorAll('.ct-guide-page').forEach(mount);
  }
  window.CTEDestinationNavigation = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) cleanup();
  });
})();
